import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './api'
import ElementUI, { Message } from 'element-ui'

import scrollReveal from 'scrollreveal'

import 'element-ui/lib/theme-chalk/index.css'

import './styles/index.less'
import _ from 'lodash'
// eslint-disable-next-line new-cap
Vue.prototype.$scroll = new scrollReveal({ reset: true })
Vue.use(ElementUI)
Vue.prototype.message = Message

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
